import LineHeartClickIcon from 'LuxKit/Icons/line/LineHeartClickIcon'
import styled from 'styled-components'
import SuggestedLabel from 'tripPlanner/components/SuggestedLabel'

/** Displays when the card's content area is at least 640px wide */
export const WideCardOnlySuggestedLabel = styled(SuggestedLabel)`
  display: none;

  @container (min-width: 640px) {
    display: inline-flex;
  }
`

/** Displays when the card's content area is less than 640px wide */
export const NarrowCardOnlySuggestedLabel = styled(LineHeartClickIcon)`
  display: inline-flex;
  color: ${props => props.theme.palette.highlight.secondary.lightContrast};

  @container (min-width: 640px) {
    display: none;
  }
`
